export const mapOrders = (list: Record<string, any>) =>
    Object.fromEntries(Object.entries(list).map(([key, value]) => [key, value ? 'DESC' : 'ASC']));
